import { paginatorStoreSelector, searchStoreSelector } from '@warehouse/shared/ui';
import { searchFieldsStoreSelector } from '../../../shared/ui/search-fields/search-fields.store';
import { ChildrenListStore } from './children.type';
import { childrenTableTableManagerSelector } from './children-table-manager.store';
import { parentTitleStoreSelector } from './parentTitle.store';

export const childTableStoreSelector = {
	...childrenTableTableManagerSelector,
	...paginatorStoreSelector,
	...searchStoreSelector,
	...searchFieldsStoreSelector,
	...parentTitleStoreSelector,
	isPending: (state: ChildrenListStore) => state.isPending,
	items: (state: ChildrenListStore) => state.items,
	actions: (state: ChildrenListStore) => ({
		...childrenTableTableManagerSelector.actions(state),
		...paginatorStoreSelector.actions(state),
		...searchStoreSelector.actions(state),
		...searchFieldsStoreSelector.actions(state),
		...parentTitleStoreSelector.actions(state),
	}),
};
